import { FC, createElement } from "react";
import { QuestionExpressionModel, RendererFactory } from "survey-core";
import { ReactQuestionFactory } from "survey-react-ui";

interface SectionIndexExpressionProps {
  question: QuestionExpressionModel;
}

const SectionIndexExpression: FC<SectionIndexExpressionProps> = ({
  question,
}) => {
  const { expression } = question;

  return (
    <div className="flex justify-center items-start h-[30px] w-[46px] gap-2.5 rounded-[5px] bg-[#E7EEF6] px-1.5 py-[5px]">
      <span className="text-sm font-semibold text-gray-700 ">{expression}</span>
    </div>
  );
};

ReactQuestionFactory.Instance.registerQuestion(
  "sv-section-index-expression",
  function (props: any) {
    return createElement(SectionIndexExpression, props);
  }
);

RendererFactory.Instance.registerRenderer(
  "expression",
  "section-index-expression",
  "sv-section-index-expression"
);
